import * as React from 'react';
import { ThemeProvider } from 'styled-components';
import merge from 'lodash.merge';
import { DefaultAppLayoutProvider, ErrorBoundary } from '../components';
import { Theme as DefaultVarnishTheme } from '../theme/Theme';
/**
 * A top level container for your application that handles errors cleanly,
 * makes the required theme available to child components, and sets up
 * the application layout.
 *
 * If the theme property is provided, it's deeply merged with the default Varnish
 * theme. Which means you can only provide the properties you'd like to override,
 * and those not provided will use the defaults.
 */
export const VarnishApp = ({ layout, theme, children }) => {
    const mergedTheme = merge({}, DefaultVarnishTheme, theme);
    return (React.createElement(ThemeProvider, { theme: mergedTheme },
        React.createElement(ErrorBoundary, null,
            React.createElement(DefaultAppLayoutProvider, { layout: layout || 'center-aligned' }, children))));
};
//# sourceMappingURL=VarnishApp.js.map